import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupLinkService } from '../services/group-link.service';

@Injectable()
export class GroupLinkInterceptor implements HttpInterceptor {
  private groupLinkService = inject(GroupLinkService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const groupLink = this.groupLinkService.getGroupLink();

    if (groupLink) {
      req = req.clone({
        setHeaders: {
          '3ddv-group-link': groupLink,
        },
      });
    }

    return next.handle(req);
  }
}
